"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.googleAdsUpdateBudget = exports.googleAdsUpdateBudgetResultSchema = exports.googleAdsUpdateBudgetArgsSchema = void 0;
var zod_1 = require("zod");
var common_1 = require("./common");
var googleAdsUpdateBudgetInputSchema = zod_1.z
    .object({
    campaignId: zod_1.z.string().describe('The ID of the campaign whose budget should be updated.'),
    dailyBudget: zod_1.z
        .number()
        .positive()
        .describe('New daily budget for the campaign in account currency (e.g. USD).'),
    budgetType: zod_1.z
        .enum(['DAILY', 'TOTAL'])
        .default('DAILY')
        .describe('Type of budget to update. Defaults to DAILY.'),
    totalBudget: zod_1.z
        .number()
        .positive()
        .nullish()
        .describe('Total budget for the campaign (required when budgetType is TOTAL).'),
    reason: zod_1.z
        .string()
        .nullish()
        .describe('Optional reason for budget change (for tracking purposes).'),
})
    .describe('Update the budget of a Google Ads campaign.');
exports.googleAdsUpdateBudgetArgsSchema = (0, common_1.GoogleAdsNodeArgsSchema)(googleAdsUpdateBudgetInputSchema);
var googleAdsUpdateBudgetResponseSchema = zod_1.z.object({
    success: zod_1.z.boolean(),
    campaignId: zod_1.z.string().describe('The ID of the campaign'),
    campaignName: zod_1.z.string().describe('The name of the campaign'),
    previousDailyBudget: zod_1.z.number().describe('The previous daily budget'),
    newDailyBudget: zod_1.z.number().describe('The new daily budget'),
    previousTotalBudget: zod_1.z.number().nullish().describe('The previous total budget (if applicable)'),
    newTotalBudget: zod_1.z.number().nullish().describe('The new total budget (if applicable)'),
    budgetType: zod_1.z.string().describe('The type of budget updated'),
    updatedAt: zod_1.z.string().describe('Timestamp when the budget was updated'),
    reason: zod_1.z.string().nullish().describe('Reason for budget change (if provided)'),
});
exports.googleAdsUpdateBudgetResultSchema = googleAdsUpdateBudgetResponseSchema;
exports.googleAdsUpdateBudget = (0, common_1.createEmitModeToolMetadata)({
    id: 'googleAdsUpdateBudget',
    displayName: 'Google Ads Update Budget',
    displayDescription: 'Update the budget of a Google Ads campaign.',
    category: 'ads',
    color: common_1.BRAND_COLORS.GOOGLE_ADS,
    backgroundColor: (0, common_1.createBgColor)(common_1.BRAND_COLORS.GOOGLE_ADS),
    icon: 'google_ads',
    argsSchema: exports.googleAdsUpdateBudgetArgsSchema,
}, googleAdsUpdateBudgetResponseSchema);
